<template>
    <div class="cloud-exhibit-container">
        <div v-if="isCN" class="cloud-top global-limited-1360px-container">
            <div class="cloud-exhibit-title">
                <CommonComponentsProductsTitleFunctionTitle :function-title="functionTitle" :color-index="colorIndex" />
            </div>
            <div class="cloud-card-circulation">
                <CommonComponentsSVGSolutionsCircle />
            </div>
        </div>
        <div class="cloud-bottom">
            <div class="product-cloud-endingtitle">
                <div class="global-limited-1360px-container">
                    <CommonComponentsUnionTitleProductsEnding class="ending" product-type="Cloud" />
                    <CommonComponentsProductsCloudPerformance v-if="isCN" />
                </div>
                <CommonComponentsFooter class="footer" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    gsap.registerPlugin(ScrollTrigger);

    const colorIndex = 0;
    const isCN = ifCNLocale();

    const functionTitle: FunctionTitle = {
        colorTitle: 'global_home_header_submenu_link_0_2',
        title: 'global_cloud_title_0',
        subTitle: 'global_cloud_subTitle_0',
    };

    onMounted(() => {
        // const circulation = document.querySelector('.cloud-card-circulation') as HTMLElement;
        const element = document.querySelectorAll(
            '.cloud-card-circulation .maxtext , .cloud-card-circulation .xiaofei',
        );
        const bigtext = gsap.utils.toArray(element) as Array<HTMLElement>;
        // console.log('bigtext', bigtext);
        const element2 = document.querySelectorAll('.cloud-card-circulation .line1');
        const line1 = gsap.utils.toArray(element2) as Array<HTMLElement>;
        // console.log('line', line);
        const element3 = document.querySelectorAll('.cloud-card-circulation .mintext');
        const mintext = gsap.utils.toArray(element3) as Array<HTMLElement>;
        // const all =allArray.concat(main)
        // console.log('minitext', minitext);

        ScrollTrigger.create({
            // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
            trigger: '.cloud-exhibit-container',
            scrub: true,
            start: 'top top',
            end: '+=500',
            pin: true,
            pinSpacing: true,
            animation: gsap
                .timeline()
                .fromTo(
                    '.svg-circle .mincircle',
                    {
                        opacity: 0.5,
                    },
                    {
                        opacity: 1,
                        duration: 2,
                    },
                )
                .fromTo(
                    '.svg-circle .rotate',
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 2,
                    },
                )
                .to('.svg-circle .rotate', {
                    transformOrigin: 'center',
                    rotate: 360,
                    opacity: 1,
                    duration: 2,
                })
                .fromTo(
                    bigtext,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 2,
                    },
                )
                .fromTo(
                    line1,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    '<',
                )
                .fromTo(
                    '.svg-circle .line',
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 0.6,
                        duration: 2,
                    },
                    '<',
                )
                .fromTo(
                    mintext,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    '<',
                )
                .to(bigtext, {
                    opacity: 1,
                    duration: 15,
                }),
        });
    });
</script>

<style lang="less" scoped>
    .cloud-exhibit-container {
        margin-top: 52px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        .cloud-top {
            height: 100vh;
            @media (max-width: @screen-mobile-width) {
                height: .convert(1688px) [ @vw];
            }
            .cloud-exhibit-title {
                // text-align: center;
                margin: .convert(48px) [ @vw] 0 .convert(52px) [ @vw] .convert(80px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    margin-top: .convert(50px) [ @vw-mobile];
                    margin-bottom: .convert(35px) [ @vw-mobile];
                }
            }

            .cloud-card-circulation {
                display: flex;
                margin: .convert(-30px) [ @vw] auto;
                @media (max-width: @screen-mobile-width) {
                    width: 100%;
                    height: auto;
                    margin-top: -250px;
                    transform: scale(1);
                }
                :deep(.svg-circle) {
                    height: 95vh;
                }
            }
        }
        .cloud-bottom {
            .ending {
                margin-bottom: 100px;
                @media (max-width: @screen-mobile-width) {
                    margin-bottom: .convert(46px) [ @vw-mobile];
                }
            }
        }
    }
</style>
